import StylesSwitchServiceInterface
  from '~/src/components/mui-wrappers/styled/toggle/styles/StylesSwitchServiceInterface'
import TemplateServiceStyleBase from '~/src/utils/template/TemplateServiceStyleBase'

export default class StylesSwitchServiceStyleOne extends TemplateServiceStyleBase implements StylesSwitchServiceInterface {
  public getComponentSx(): Record<string, unknown> {
    return {}
  }
}
